module.exports = __webpack_public_path__ + "img/qubepay.4e35aa60.svg";